<template>
    <fr-center-card  :showLogo="true">
        <b-card-body slot="center-card-body">
            <div slot="center-card-header">
                <h2 class="h2">{{$t('pages.selfservice.registration.registerYourAccount')}}</h2>
            </div>
            <br>
            <div>
                <b-alert variant="success" show>
                    <p>{{$t('pages.selfservice.registration.successfullyRegistered')}}</p>
                </b-alert>
                <div v-if="gotoLink">
                    <a :href="gotoLink">{{ $t('pages.selfservice.registration.success.goToUrlText')}}</a>
                </div>
            </div>
        </b-card-body>
    </fr-center-card>
</template>

<script>
import CenterCard from '@/components/utils/CenterCard';
/**
* @description Selfservice stage for password reset, handles the final result of password reset, either displaying an error or that the reset has been complete
*
**/
export default {
    name: 'success',
    components: {
        'fr-center-card': CenterCard
    },
    computed: {
        gotoLink () {
            return this.$route.query.goto || null;
        }
    }
};
window.gaEvent('Register', 'Register', 'Success', 'Register success');
</script>
<style scoped lang="scss">
@import '../../../scss/pearson-common.css';
</style>
